import VNLoginApi from '../VNLogin/apis/VNLoginApi'
import BaseRemote from './baseRemote'

const instance = new BaseRemote(process.env.REACT_APP_OIDC_ISSUER)

export class PorticoRemote {
  static getPusherInfo = () => {
    const response = instance.get('/pusher/info', {})
    return response
  }

  static getDeviceInfo = ({ deviceId, serialNumber, isSummit }) => {
    if (isSummit) {
      const payload = {
        params: {
          venue_uuid: process.env.REACT_APP_VENUE_UUID,
          serial_number: serialNumber,
        },
      }
      return instance.get(`/devices/manager`, payload)
    }

    const response = instance.get(`/devices/manager/${deviceId}?venue_uuid=${process.env.REACT_APP_VENUE_UUID}`, {})
    return response
  }

  /**
   * Post to the login endpoint to retrieve an access token
   * @returns {Promise} - Axios response Promise
   */
  static postLogin = () => {
    return VNLoginApi().postDeviceLogin()
  }
}

export default PorticoRemote
